import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import availableRrcCouponsSelector from 'selectors/availableRrcCoupons/availableRrcCouponsSelector';
import BeautyInsiderSelector from 'selectors/beautyInsider/beautyInsiderSelector';
import basketSelector from 'selectors/basket/basketSelector';
import {
    applyRougeCashReward,
    removeRougeCashReward,
    showRougeRewardLearnMoreModal
} from 'actions/RougeRewardsActions';
import Empty from 'constants/empty';

const { wrapHOC } = FrameworkUtils;
const { beautyInsiderSelector } = BeautyInsiderSelector;

const fields = createSelector(
    userSelector,
    availableRrcCouponsSelector,
    beautyInsiderSelector,
    basketSelector,
    (user, availableRrcCoupons, beautyInsider, basket) => {
        const bankRewards = user.ccRewards?.bankRewards || Empty.Object;
        const rrcCoupons = availableRrcCoupons?.coupons || Empty.Array;
        const biSummary = beautyInsider.summary || Empty.Object;

        // Extract applied promo codes from basket (normalize to lowercase for case-insensitive comparison)
        // Handle both string entries and object entries with couponCode property
        const appliedPromoCodes = (basket.appliedPromotions || Empty.Array)
            .map(promo => (typeof promo === 'string' ? promo : promo?.couponCode))
            .filter(Boolean)
            .map(code => code.toLowerCase());

        return {
            bankRewards,
            availableRrcCoupons: rrcCoupons,
            biSummary,
            basket,
            appliedPromoCodes
        };
    }
);

const functions = dispatch => ({
    onApplyRougeReward: couponCode => dispatch(applyRougeCashReward(couponCode)),
    onRemoveRougeReward: couponCode => dispatch(removeRougeCashReward(couponCode)),
    onShowLearnMore: coupon => dispatch(showRougeRewardLearnMoreModal(coupon))
});

const withBeautyInsiderRewardsSummaryProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderRewardsSummaryProps, fields, functions
};
